/*LIBRARY*/
import { useEffect } from "react";
import { connect } from "react-redux";
import { CSVLink } from "react-csv";

/*COMPONENT*/

/*REDUX*/
import { getDetailLayerById } from "../../App/actions/get_features_action";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";
import domain_list from "../../Data/domain_list";
import { set_value_layer } from "../../App/actions/layerActions";
import formatDate, { isValidDate } from "../../App/validation/format-date";

/*CONST*/
const limit_char = 17;

const TableEditViaForm = ({
  layer,
  auth,
  project,
  getDetailLayerById,
  set_value_layer,
}) => {
  useEffect(() => {
    const { geo_project } = project;
    const { geo_layer_list, layer_id } = layer;

    const geo_layer = geo_layer_list.find(
      (item) => item?.geo_layer?._id === layer_id
    );
    const geo_layer_item = geo_layer?.geo_layer;
    const features = geo_layer_item?.geojson?.features || [];

    if (features.length === 0) {
      const body = {
        geo_layer_id: geo_layer_item?._id,
        geo_project_id: geo_project?._id,
        flyStatus: true,
        folder_id: "",
        geo_layer_item: geo_layer_item,
      };
      getDetailLayerById(body);
    }

    return () => {
      set_value_layer({
        key: "modal_link_edit",
        value: false,
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //local storage
  const language = localStorage?.language || auth.language;

  //local state

  //global props
  const { domain } = auth;

  const domain_temp = domain.includes("192.168.1")
    ? domain_list?.["localhost"]?.form_link
    : domain_list?.[domain]?.form_link;

  const { geo_layer_list, layer_id } = layer;
  const geo_layer = geo_layer_list.find(
    (item) => item?.geo_layer?._id === layer_id
  );
  const geo_layer_item = geo_layer?.geo_layer;

  const features = geo_layer_item?.geojson?.features || [];

  const fields = geo_layer_item?.fields ? geo_layer_item?.fields : [];
  const fields_filtered = fields.filter(
    (field) =>
      !field.isHide &&
      !field.isStyle &&
      !["section"].includes(field?.type) &&
      !field.parent_uuid
  );

  let csvData = features.map((feature) => {
    const { properties } = feature;
    let object = {
      link: `${domain_temp}${geo_layer_item.link}/step_1/${feature.key}`,
    };
    if (fields_filtered.length > 0) {
      object = {
        [fields_filtered[0].name]: properties[fields_filtered[0].key],
        link: `${domain_temp}${geo_layer_item.link}/step_1/${feature.key}`,
      };
    }
    return object;
  });
  let headers = [
    {
      label: "Link untuk edit",
      key: "link",
    },
  ];
  if (fields_filtered.length > 0) {
    headers = [
      {
        label: fields_filtered[0].name,
        key: fields_filtered[0].name,
      },
      {
        label: "Link untuk edit",
        key: "link",
      },
    ];
  }

  return (
    <main style={{ overflow: "scroll" }}>
      <table className="table_lite" style={{ minWidth: "100%" }}>
        <thead>
          <tr>
            <th style={{ minWidth: "100px" }}>
              <CSVLink
                filename={geo_layer_item?.name}
                data={csvData}
                headers={headers}
                style={{ color: "#fff", display: "block" }}
              >
                {dict["Download links as CSV"][language]}
              </CSVLink>
            </th>
            {fields_filtered.map((field, idx) => {
              return (
                <th key={idx} style={{ minWidth: "100px" }}>
                  {field?.name?.slice(0, limit_char)}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {features.map((feature, idx) => {
            return (
              <tr key={idx}>
                <th
                  style={{
                    backgroundColor: "#fff",
                    color: "#000",
                    fontWeight: "bold",
                  }}
                >
                  {idx + 1}
                  <br />
                  <a
                    href={`${domain_temp}${geo_layer_item.link}/step_3/${feature.key}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="button_small background_black"
                  >
                    Link edit
                  </a>
                </th>
                {fields_filtered.map((field, idx) => {
                  let content;
                  if (isNaN(feature?.properties?.[field?.key])) {
                    const str_content = feature?.properties?.[field?.key];
                    if (isValidDate(str_content))
                      content = formatDate(str_content);
                    else {
                      if (str_content) {
                        if (str_content > limit_char)
                          content = `${str_content.slice(0, limit_char)}...`;
                        else content = str_content;
                      } else {
                        content = "-";
                      }
                    }
                  } else {
                    content = feature?.properties?.[field?.key] || 0;
                  }
                  return (
                    <td key={idx} title={content}>
                      {content}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </main>
  );
};

const mapStateToProps = (state) => ({
  layer: state.layer,
  auth: state.auth,
  project: state.project,
});

export default connect(mapStateToProps, {
  getDetailLayerById,
  set_value_layer,
})(TableEditViaForm);
